import * as React from 'react'
import { Grid, FormControlLabel, MenuItem, Radio } from '@material-ui/core'
import { Field, reduxForm, InjectedFormProps, change, formValueSelector } from 'redux-form'
import { TextField, RadioGroup, Select } from 'redux-form-material-ui'
import autobind from 'autobind-decorator'
import { compose } from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {connect} from 'react-redux'
import { Validator } from 'src/core/form/Validator'
import { QuestionWpr } from 'src/shared/form/QuestionWpr'
import Alert from 'src/shared/Alert/Alert'
import DateField from 'src/shared/form/DateField'
import DurationField from 'src/shared/form/DurationField'
import DocumentField from 'src/shared/form/DocumentField'
import { ICollarKIKO, periodicityCouponsDette, amortissementDette, indiceSousJacentDette } from 'src/type/cotation-form'
import CurrencyField from 'src/shared/form/CurrencyField'
import { uploadDocument } from 'src/core/redux/action/documentAction'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import { parseNumber } from 'src/shared/utils/helpers'
import NegativeNumberField from 'src/shared/form/NegativeNumberField'
import SelectWithField from 'src/shared/form/SelectWithField'

const validate = values => Validator.buildWithCheckAll(values, {
    nominal_du_pret: [Validator.required],
    date_de_depart: [Validator.required],
    duree_de_la_couverture: [Validator.required],
    periodicite: [Validator.required],
    amortissement: [Validator.required],
    indice_sous_jacent: [Validator.required],
    constatation_du_fixing: [Validator.negativeNumberRequired],
    type_de_fixing: [Validator.required],
    calendrier: [Validator.required],
    convention_de_calcul_interet: [Validator.required],
    convention_de_paiement: [Validator.required],
}, checkAll);

const checkAll = (values, dispatch) => {
    if(values.dureeDeLaCouverture && values.dureeDuPretSousJacent && values.dureeDeLaCouverture <= values.dureeDuPretSousJacent){
       return "form error"
    } else {
        return undefined
    }
}   

interface IProps extends WithI18n,
  WithToast,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  onSubmit: (values: any) => void;
}

class CollarKIKOForm extends React.Component<IProps & InjectedFormProps<ICollarKIKO>, {}> {

    render(){
        const {onSubmit, dureeDuPretSousJacent, dureeDeLaCouverture, cap, floor, ko, ki} = this.props

        return(
            <form onSubmit={onSubmit}>
                <Grid container>
                    <Grid item xs={12}>
                        <QuestionWpr
                            label="Nominal du prêt (EUR)"
                            isRequired={true}
                        >
                            <Field
                                name="nominal_du_pret"
                                component={CurrencyField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Date de valeur"
                            isRequired={true}
                        >
                            <Field
                                name="date_de_depart"
                                component={DateField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Durée du prêt sous-jacent"
                        >
                            <Field
                                name="duree_du_pret_sous_jacent"
                                component={DurationField}
                                durationType={["year", "month"]}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Durée de couverture"
                            isRequired={true}
                        >
                            <Field
                                name="duree_de_la_couverture"
                                component={DurationField}
                                durationType={["year", "month"]}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Périodicité"
                            isRequired={true}
                        >
                            <Field
                                name="periodicite"
                                component={Select}
                                fullWidth={true}
                            >
                                {this.renderSelectItemByArr(periodicityCouponsDette)}
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label="Date du premier flux"
                            description="La date du premier flux est nécessaire si la première période n’est pas complète"
                        >
                            <Field
                                name="date_de_premier_flux"
                                component={DateField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Amortissement"
                            isRequired={true}
                        >
                            <Field
                                name="amortissement"
                                component={Select}
                                fullWidth={true}
                            >
                                {this.renderSelectItemByArr(amortissementDette)}
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label="Indice sous-jacent"
                            isRequired={true}
                        >
                            <Field
                                name="indice_sous_jacent"
                                component={SelectWithField}
                                arrOptions={indiceSousJacentDette}
                                otherOptionPlaceHolder={"Saisissez votre indice sous-jacent…"}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Spread (bp)"
                        >
                            <Field
                                name="spread"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Constatation du fixing"
                            description="J-1, J-2, J-X (la valeur renseignée représente le nombre de jours à retrancher à J)"
                            isRequired={true}
                        >
                            <Field
                                name="constatation_du_fixing"
                                component={NegativeNumberField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Type de fixing"
                            isRequired={true}
                            isCheckBox={true}
                        >
                            <Field
                                name="type_de_fixing"
                                component={RadioGroup}
                            >
                                <FormControlLabel
                                    value="pré-fixé"
                                    control={<Radio color="primary" />}
                                    label="pré-fixé"
                                />
                                <FormControlLabel
                                    value="post-fixé"
                                    control={<Radio color="primary" />}
                                    label="post-fixé"
                                />
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label="Calendrier"
                            isRequired={true}
                        >
                            <Field
                                name="calendrier"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>
                        
                        <QuestionWpr
                            label="Convention de calcul d’intérêt"
                            isRequired={true}
                            isCheckBox={true}
                        >
                            <Field
                                name="convention_de_calcul_interet"
                                component={RadioGroup}
                            >
                                <FormControlLabel
                                    value="Ajusté"
                                    control={<Radio color="primary" />}
                                    label="Ajusté"
                                />
                                <FormControlLabel
                                    value="Non ajusté"
                                    control={<Radio color="primary" />}
                                    label="Non ajusté"
                                />
                            </Field>
                        </QuestionWpr>
                        
                        <QuestionWpr
                            label="Convention de paiement"
                            isRequired={true}
                            isCheckBox={true}
                        >
                            <Field
                                name="convention_de_paiement"
                                component={RadioGroup}
                            >
                                <FormControlLabel
                                    value="Following"
                                    control={<Radio color="primary" />}
                                    label="Following"
                                />
                                <FormControlLabel
                                    value="Modified Following"
                                    control={<Radio color="primary" />}
                                    label="Modified Following"
                                />
                            </Field>
                        </QuestionWpr>
                        
                        <QuestionWpr
                            label="Strike plafond (CAP)"
                        >
                            <Field
                                name="strike_cap"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Strike de désactivation (KO)"
                        >
                            <Field
                                name="strike_ko"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Strike plancher (FLOOR)"
                        >
                            <Field
                                name="strike_floor"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Strike d’activation (KI)"
                        >
                            <Field
                                name="strike_ki"
                                type="number"
                                component={TextField}
                                fullWidth={true}
                            />
                        </QuestionWpr>

                        <QuestionWpr
                            label="Nature de la prime de couverture"
                            isCheckBox={true}
                        >
                            <Field
                                name="nature_de_la_prime_de_couverture"
                                component={RadioGroup}
                            >
                                <FormControlLabel
                                    value="running (périodique)"
                                    control={<Radio color="primary" />}
                                    label="running (périodique)"
                                />
                                <FormControlLabel
                                    value="up front (mise en place)"
                                    control={<Radio color="primary" />}
                                    label="up front (mise en place)"
                                />
                            </Field>
                        </QuestionWpr>

                        <QuestionWpr
                            label="Tableau d'amortissement"
                        >
                            <Field
                                name="tableau_amortissement_url"
                                component={DocumentField}
                                onUploadFile={this.uploadFile}
                                fullWidth={true}/>
                        </QuestionWpr>

                    </Grid>
                    
                    {dureeDeLaCouverture !== undefined && dureeDuPretSousJacent !== undefined && dureeDuPretSousJacent < dureeDeLaCouverture &&
                        <Grid item xs={12}>
                            <Alert type="error">
                                <p>La durée de couverture doit être inférieure ou égale à la durée du prêt du sous-jacent.</p>
                            </Alert>
                        </Grid>
                    }

                    {(
                        (ko !== undefined && cap !== undefined && ko < cap) || 
                        (ko !== undefined && floor !== undefined && ko < floor) ||
                        (ko !== undefined && ki !== undefined && ko < ki) ||
                        (floor !== undefined && cap !== undefined && cap < floor) ||
                        (ki !== undefined && cap !== undefined && cap < ki) ||
                        (floor !== undefined && ki !== undefined && floor < ki)
                    ) &&
                        <Grid item xs={12}>
                            <Alert type="info">
                                {ko !== undefined && cap !== undefined && ko < cap &&
                                    <p>Le strike de désactivation doit être supérieur au strike plafond.</p>
                                }
                                {ko !== undefined && floor !== undefined && ko < floor &&
                                    <p>Le strike de désactivation doit être supérieur au strike plancher.</p>
                                }
                                {ko !== undefined && ki !== undefined && ko < ki &&
                                    <p>Le strike de désactivation doit être supérieur au strike d'activation.</p>
                                }
                                {floor !== undefined && cap !== undefined && cap < floor &&
                                    <p>Le strike plafond doit être supérieur au strike plancher.</p>
                                }                                                                                                           
                                {ki !== undefined && cap !== undefined && cap < ki &&
                                    <p>Le strike plafond doit être supérieur au strike d'activation.</p>
                                }
                                {floor !== undefined && ki !== undefined && floor < ki &&
                                    <p>Le strike plancher doit être supérieur au strike d'activation.</p>
                                }
                            </Alert>
                        </Grid>
                    }
                </Grid>
            </form>
        )
    }

    componentWillMount(){
        if(!this.props.initialValues){
            this.props.setValue("periodicite", "Trimestrielle")
            this.props.setValue("amortissement", "Linéaire")
            this.props.setValue("indice_sous_jacent", "EURIBOR 3M")
            this.props.setValue("constatation_du_fixing", -2)
            this.props.setValue("type_de_fixing", "pré-fixé")
            this.props.setValue("calendrier", "Target")
            this.props.setValue("convention_de_calcul_interet", "Non ajusté")
            this.props.setValue("convention_de_paiement", "Modified Following")
            this.props.setValue("nature_de_la_prime_de_couverture", "running (périodique)")
        }
    }

    @autobind
    private renderSelectItemByArr(arr: any[]){
        return arr.map(a => (
            <MenuItem key={a} value={a}>{a}</MenuItem>
        ))
    }

    uploadFile = (file, callback) => {
        const data = new FormData();
        data.append("file", file);
        data.append("name", file.name);
        this.props.uploadDoc(data).then(res =>
            callback({
                name: file.name,
                permalink: res.permalink
            })
        ).catch(err => this.props.toastError(err.msg))
    }
}

const formName = 'COLLAR_KI_KO_form';

const state2props = (state, props) => ({
    dureeDuPretSousJacent: parseNumber("int", formValueSelector(formName)(state, 'duree_du_pret_sous_jacent')),
    dureeDeLaCouverture: parseNumber("int", formValueSelector(formName)(state, 'duree_de_la_couverture')),
    cap: parseNumber("float", formValueSelector(formName)(state, 'strike_cap')),
    floor: parseNumber("float", formValueSelector(formName)(state, 'strike_floor')),
    ko: parseNumber("float", formValueSelector(formName)(state, 'strike_ko')),
    ki: parseNumber("float", formValueSelector(formName)(state, 'strike_ki')),
});

const dispatch2props = (dispatch: any) => ({
    setValue: (field, value) => dispatch(change(formName, field, value)),
    uploadDoc: (document: any) => dispatch(uploadDocument(document))
    
});
  
export default compose(
    withToast,
    withI18n,
    connect(state2props, dispatch2props)
)(reduxForm<ICollarKIKO, IProps>({
    form: formName,
    validate
})(CollarKIKOForm))



// WEBPACK FOOTER //
// ./src/shared/Cotation/form/CollarKIKOForm.tsx